<template>
    <v-list-item link :to="item.route" :exact-path="!!item.exactPath" class="menu-item rounded-lg" active-class="menu-item--active"
        @click.native="emitEvent(item)">
        <v-list-item-icon class="mr-3">
            <v-icon size="18" class="menu-item-icon">{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
            <v-list-item-title class="menu-item-text">{{ item.name }}</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
import { eventHub } from "@/main";

export default {
    name: "MenuItem",

    props: ["item"],

    methods: {
        emitEvent(item) {
            if (item.event) {
                eventHub.$emit(item.event)
                return;
            }

            eventHub.$emit('close-menu');
        },
    },
};
</script>

<style lang="scss" scoped>
.menu-item {
    min-height: 38px;
    max-height: 38px;
    margin-bottom: 2px;
    transition: all 0.15s ease;

    .menu-item-icon {
        color: #565674 !important;
    }

    .menu-item-text {
        font-size: 13px;
        font-weight: 400;
        color: #9D9DA6;
    }

    &:hover {
        background: rgba(255, 255, 255, 0.06);

        .menu-item-icon {
            color: #FFFFFF !important;
        }

        .menu-item-text {
            color: #FFFFFF;
        }
    }

    &.v-list-item--active,
    &.menu-item--active {
        background: rgba(255, 255, 255, 0.12) !important;

        .menu-item-icon {
            color: #FFFFFF !important;
        }

        .menu-item-text {
            color: #FFFFFF;
            font-weight: 600;
        }
    }
}
</style>
